import React, { useState, useEffect, useMemo } from 'react'
import { FaArrowRight } from 'react-icons/fa'
import { Eyeglasses, Search } from 'react-bootstrap-icons'
import { toast } from 'react-toastify'
import apinode from '../../services/apinode'
import { Modal, Table, Form, Row, Col } from 'react-bootstrap'
import './custo.css'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import Navbar from '../../components/navbar/navbar.jsx'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage.js'
import { CustomButton } from '../../components/CustomButton'
import CategoriesService from '../../services/database/CategoriesService/index.js'
import { unifyParams } from '../../utils/unifyParams.js'
import { useOrdenation } from '../../hooks/useOrdenation/index.js'
import { ModalAjustarPrecos } from './ModalAjustarPrecos.jsx'

const CentroDeCusto = () => {
  const [productsLoading, setIsProductsLoading] = useState(false)
  const [products, setProducts] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [composicao, setComposicao] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [historico, setHistorico] = useState([])
  const [showModalCusto, setShowModalCusto] = useState(false)
  const [novoCusto, setNovoCusto] = useState(0) // Estado local para armazenar o novo custo
  const [novoPrecoVenda, setNovoPrecoVenda] = useState({}) // Novo pre�o de venda
  const [novoPrecoAtacado, setNovoPrecoAtacado] = useState({}) // Novo pre�o atacado
  const [novoPrecoPromocional, setNovoPrecoPromocional] = useState({}) // Novo pre�o promocional
  const [novoPrecoAtacadoPromocional, setnovoPrecoAtacadoPromocional] =
    useState({})
  const navigate = useNavigate()
  const [countdown, setCountdown] = useState(5) // Inicializa o contador em 5 segundos
  const [unidade, setUnidade] = useState('UN')
  const [markupPercentage, setMarkupPercentage] = useState(0) // Porcentagem de markup
  const [markupPercentageAtacado, setMarkupPercentageAtacado] = useState(0) // Porcentagem de markup
  const [isLoading, setIsLoading] = useState(false)
  const [marcas, setMarcas] = useState([])
  const [selectedMarca, setSelectedMarca] = useState('')
  const [selectCategoria, setSelectCategoria] = useState('')
  const [categorias, setCategorias] = useState([])
  const [filtroEstoque, setFiltroEstoque] = useState('')
  const [selectedProducts, setSelectedProducts] = useState([])
  const [isModalAjustarOpen, setIsModalAjustarOpen] = useState(false)

  const filtered = useMemo(() => {
    let data = products

    if (filtroEstoque) {
      data = data.filter((p) =>
        filtroEstoque === 'com_estoque'
          ? Number(p.QTESTGER) > 0
          : Number(p.QTESTGER) == 0,
      )
    }

    return data
  }, [products, filtroEstoque])

  const { filteredItems, Th, itemsPerPage, setItemsPerPage, Paginate } =
    useOrdenation(filtered, 'DESCRICAO', 'asc', 100)

  const handleMarcaChange = (event) => {
    setSelectedMarca(event.target.value)
  }

  async function loadCategorias() {
    try {
      const data = await CategoriesService.getAll()

      setCategorias(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar as categorias!')
    }
  }

  async function fetchMarcas() {
    setIsProductsLoading(true)

    try {
      const response = await apinode.get(
        `/estoque/marca/${localStorage.idconta}`,
      )

      setMarcas(response.data)
    } catch (error) {
      setError(error)
      toast.error('Erro ao buscar marcas, Resposta:', error)
    } finally {
      setIsProductsLoading(false)
    }
  }

  // Função para atualizar o valor da porcentagem de markup
  const handleMarkupChange = (e) => {
    const percentage = parseFloat(e.target.value)
    setMarkupPercentage(percentage) // Atualiza a porcentagem de markup
    updatePrices(percentage) // Recalcula os preços com a nova porcentagem
  }

  const handleMarkupChangeAtacado = (e) => {
    const percentage = parseFloat(e.target.value)
    setMarkupPercentageAtacado(percentage) // Atualiza a porcentagem de markup
    updatePricesAtacado(percentage) // Recalcula os preços com a nova porcentagem
  }

  // Função que recalcula os preços com base no custo e a porcentagem de markup
  const calculateSalePrice = (custo, percentage) => {
    return (custo * (1 + percentage / 100)).toFixed(2)
  }

  // Função para atualizar todos os preços
  const updatePrices = (percentage) => {
    const updatedNovoCusto = {}
    const updatedNovoPrecoVenda = {}
    const updatedNovoPrecoAtacado = {}
    const updatedNovoPrecoPromocional = {}
    const updatedNovoPrecoAtacadoPromocional = {}

    products.forEach((produto) => {
      const custo = produto.PRECOCUSTO
      updatedNovoCusto[produto.CODPRODUTO] = custo

      updatedNovoPrecoVenda[produto.CODPRODUTO] = calculateSalePrice(
        custo,
        percentage,
      )
      updatedNovoPrecoAtacado[produto.CODPRODUTO] = calculateSalePrice(
        custo,
        percentage,
      )
      updatedNovoPrecoPromocional[produto.CODPRODUTO] = calculateSalePrice(
        custo,
        percentage,
      )
      updatedNovoPrecoAtacadoPromocional[produto.CODPRODUTO] =
        calculateSalePrice(custo, percentage)
    })

    // Atualiza todos os estados ao mesmo tempo
    setNovoCusto(updatedNovoCusto)
    setNovoPrecoVenda(updatedNovoPrecoVenda)

    /*  setNovoPrecoPromocional(updatedNovoPrecoPromocional);
      setnovoPrecoAtacadoPromocional(updatedNovoPrecoAtacadoPromocional); */
  }

  const updatePricesAtacado = (percentage) => {
    const updatedNovoCusto = {}
    const updatedNovoPrecoVenda = {}
    const updatedNovoPrecoAtacado = {}
    const updatedNovoPrecoPromocional = {}
    const updatedNovoPrecoAtacadoPromocional = {}

    products.forEach((produto) => {
      const custo = produto.PRECOCUSTO
      updatedNovoCusto[produto.CODPRODUTO] = custo

      updatedNovoPrecoVenda[produto.CODPRODUTO] = calculateSalePrice(
        custo,
        percentage,
      )
      updatedNovoPrecoAtacado[produto.CODPRODUTO] = calculateSalePrice(
        custo,
        percentage,
      )
      updatedNovoPrecoPromocional[produto.CODPRODUTO] = calculateSalePrice(
        custo,
        percentage,
      )
      updatedNovoPrecoAtacadoPromocional[produto.CODPRODUTO] =
        calculateSalePrice(custo, percentage)
    })

    // Atualiza todos os estados ao mesmo tempo

    setNovoPrecoAtacado(updatedNovoPrecoAtacado)
    /*  setNovoPrecoPromocional(updatedNovoPrecoPromocional);
      setnovoPrecoAtacadoPromocional(updatedNovoPrecoAtacadoPromocional); */
  }

  const ProductModal = ({ show, handleClose, composicao }) => {
    const calcularCustoMedio = (composicao) => {
      let total = 0
      let quantidadeTotal = 0

      composicao.forEach((item) => {
        if (item.qtestger > 0 && item.precocusto > 0) {
          total += item.qtestger * item.precocusto
          quantidadeTotal += item.qtestger
        }
      })
      if (quantidadeTotal === 0) return 0

      return (total / quantidadeTotal).toFixed(2)
    }

    let custoMedio = 0

    if (composicao.some((item) => item.qtestger > 0)) {
      custoMedio = calcularCustoMedio(composicao)
    }

    if (composicao.length > 0) {
      custoMedio = calcularCustoMedio(composicao)
    }

    return (
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="custom-modalzpl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Composição</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table
            striped
            bordered
            hover
          >
            <thead>
              <tr>
                <th>SKU</th>
                <th>Descrição</th>
                <th>Quantidade</th>
                <th>Preço de Custo</th>
              </tr>
            </thead>
            <tbody>
              {composicao.length === 0 ? (
                <tr>
                  <td colSpan="4">Produto sem composiçao</td>
                </tr>
              ) : (
                composicao.map((item) => (
                  <tr key={item.sku}>
                    <td>{item.sku}</td>
                    <td>{item.descricao}</td>
                    <td>{item.qtestger}</td>
                    <td>{item.precocusto}</td>
                  </tr>
                ))
              )}
              {custoMedio > 0 && (
                <tr>
                  <td
                    style={{ color: 'blue', fontFamily: 'Arial' }}
                    colSpan="3"
                  >
                    Custo Médio
                  </td>
                  <td style={{ color: 'blue', fontFamily: 'Arial' }}>
                    {custoMedio}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          <p
            style={{
              color: 'black',
              fontFamily: 'Arial',
              padding: '10px',
              backgroundColor: '#f0f0f0',
              borderRadius: '5px',
            }}
          >
            Custo médio é calculado somando o custo de cada item ao estoque
            positivo.
          </p>
        </Modal.Body>
      </Modal>
    )
  }

  const handleCloseModalCusto = () => {
    setShowModalCusto(false)
  }

  async function fetchProductsAll() {
    setIsProductsLoading(true)

    const url = unifyParams(`/estoque/${localStorage.idconta}`, [
      {
        key: 'unidade',
        value: unidade,
      },
      {
        key: 'descricao',
        value: searchTerm,
      },
      {
        key: 'categoria',
        value: selectCategoria,
      },

      {
        key: 'marca',
        value: selectedMarca,
      },
    ])

    try {
      const response = await apinode.get(url)

      setProducts(response.data)
    } catch (error) {
      sendErrorApiMessage(error, 'Erro ao buscar os produtos!')
    } finally {
      setIsProductsLoading(false)
    }
  }

  useEffect(() => {
    loadCategorias()
    fetchMarcas()

    if (localStorage.getItem('admin') !== 'SIM') {
      let timerInterval
      Swal.fire({
        title: 'Acesso negado',
        text: 'Você não tem permissão para acessar esta página.',
        timer: 5000, // 5000 milissegundos = 5 segundos
        timerProgressBar: true,
        didClose: () => {
          clearInterval(timerInterval)
          navigate(-1) // Redireciona para a p�gina anterior
        },
        onBeforeOpen: () => {
          Swal.showLoading()
          timerInterval = setInterval(() => {
            setCountdown((prev) => {
              if (prev === 0) {
                clearInterval(timerInterval)
                navigate(-1) // Redireciona para a p�gina anterior
              }
              return prev - 1
            })
            const currentCountdown = countdown // Captura o valor atualizado de countdown
            Swal.update({
              text: `Redirecionando em ${currentCountdown} segundos...`,
            })
          }, 1000) // Atualiza a cada segundo
        },
        onClose: () => {
          clearInterval(timerInterval)
        },
      })
    } else {
      fetchProductsAll()
    }
  }, [navigate, countdown])

  function reset() {
    fetchProductsAll()
  }

  const handleAtualizar = async (id, tipo, novoValor) => {
    try {
      const url = `/custos/atualizar/${tipo}/${id}/${localStorage.idconta}`

      const response = await apinode.put(url, { valor: novoValor })

      if (response.status === 200) {
        toast.success('Produto atualizado com sucesso!')
        fetchProductsAll()
      } else {
        toast.error('Erro ao atualizar produto')
      }
    } catch (error) {
      toast.error('Erro ao atualizar produto', error)
    } finally {
      setIsProductsLoading(false)
    }
  }

  useEffect(() => {
    filtered.forEach((item) => {
      const index = selectedProducts.findIndex((prod) => prod.SKU === item.SKU)

      if (index !== -1) {
        setSelectedProducts((prevState) =>
          prevState.with(index, {
            ...prevState[index],
            ...item,
          }),
        )
      }
    })
  }, [filtered, selectedProducts])

  /*   const handleAtualizar = async (id, tipo, novoValor) => {
      try {
        const url =
          tipo === 'custo'
            ? `/custos/atualizar-custo/${id}/${localStorage.idconta}`
            : tipo === 'venda'
            ? `/produtos/atualizar-preco-venda/${id}/${localStorage.idconta}`
            : tipo === 'atacado'
            ? `/produtos/atualizar-preco-atacado/${id}/${localStorage.idconta}`
            : `/produtos/atualizar-preco-promocional/${id}/${localStorage.idconta}`

        const response = await apinode.put(url, { valor: novoValor })

        if (response.status === 200) {
          toast.success('Produto atualizado com sucesso!')
          fetchProductsAll()
        } else {
          toast.error('Erro ao atualizar produto')
        }
      } catch (error) {
        toast.error('Erro ao atualizar produto', error)
      } finally {
        setIsProductsLoading(false)
      }
    } */

  const handleProdFilho = async (id) => {
    try {
      const response = await apinode.get(
        `/custos/listacomposicao/${id}/${localStorage.idconta}`,
      ) // Realiza a solicita��o GET

      setComposicao(response.data)
      console.log(response.data)
      setShowModal(true)
    } catch (error) {
      toast.error('Erro ao buscar produtos, Resposta:', error)
    } finally {
      setIsProductsLoading(false)
    }
  }

  const handleHistorico = async (id) => {
    try {
      const response = await apinode.get(
        `/custos/${id}/${localStorage.idconta}`,
      ) // Realiza a solicita��o GET

      if (response.data.length > 0) {
        setHistorico(response.data)
        setShowModalCusto(true)
      } else {
        toast('Sem movimentações de Custo')
      }
    } catch (error) {
      toast.error('Erro ao buscar produtos, Resposta:' + error.message)
    } finally {
      setIsProductsLoading(false)
    }
  }

  const handleSearch = (e) => {
    setSearchTerm(e.target.value)
  }

  const handleSendToBackend = async () => {
    // Pergunta ao usuário antes de enviar os dados
    const confirmSend = window.confirm(
      'Você tem certeza que deseja enviar os dados para o backend?',
    )

    if (!confirmSend) {
      return // Sai da função se o usuário cancelar
    }

    // Inicia o carregamento
    setIsLoading(true)

    // Cria um array de objetos com SKU e PRECOVENDA
    const payload = products.map((product) => ({
      SKU: product.SKU,
      PRECOVENDA: novoPrecoVenda[product.CODPRODUTO] || product.PRECOVENDA, // Usando novo preco se disponível
    }))

    try {
      // Envia os dados ao backend
      console.log(payload)
      const response = await apinode.post(
        `/estoque/enviar-produtos/${localStorage.idconta}`,
        payload,
      )

      // Finaliza o loading
      setIsLoading(false)

      if (response.status === 200) {
        toast.success('Dados enviados com sucesso!')
      } else {
        toast.error('Erro ao enviar os dados')
      }
    } catch (error) {
      // Finaliza o loading mesmo em caso de erro
      setIsLoading(false)
      toast.error('Erro ao enviar os dados: ' + error.message)
    }
  }

  return (
    <>
      <Navbar />
      <div className="container mt-page">
        <h1 className="mb-4">Centro de Custo</h1>
        <Row
          xs={5}
          style={{
            display: 'flex',
            alignItems: 'flex-end',
          }}
        >
          <Col>
            <input
              type="text"
              placeholder="Pesquisar produto"
              value={searchTerm}
              onChange={handleSearch}
              className="form-control"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  fetchProductsAll()
                }
              }}
            />
          </Col>

          <Col>
            <Form.Select
              value={unidade}
              onChange={(e) => setUnidade(e.target.value)}
            >
              <option value="un">UN</option>
              <option value="kit">KIT</option>
            </Form.Select>
          </Col>

          <Col>
            <select
              className="form-select"
              aria-label="Small select example"
              value={selectCategoria}
              onChange={(e) => setSelectCategoria(e.target.value)}
            >
              <option value="">Selecione uma categoria</option>
              {categorias.map((categoria) => (
                <option
                  key={categoria.id_categoria}
                  value={categoria.id_categoria}
                >
                  {categoria.categoria}
                </option>
              ))}
            </select>
          </Col>

          <Col>
            <select
              className="form-select"
              aria-label="Small select example"
              value={selectedMarca}
              onChange={handleMarcaChange}
            >
              <option value="">Selecione uma marca</option>
              {marcas.map((marca) => (
                <option
                  key={marca.ID_MARCA}
                  value={marca.ID_MARCA}
                >
                  {marca.DESC_MARCA}
                </option>
              ))}
            </select>
          </Col>

          <Col>
            <CustomButton
              title="Buscar"
              style={{
                margin: 0,
              }}
              onClick={() => fetchProductsAll()}
            >
              <Search />
            </CustomButton>
          </Col>
        </Row>

        <Row className="mt-4 d-flex align-items-center">
          <Col xs="auto">
            <label
              htmlFor="markupPercentageInput"
              style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 'bold',
              }}
            >
              % Preço
            </label>
            <input
              id="markupPercentageInput"
              type="number"
              placeholder="% Preço"
              value={markupPercentage}
              onChange={handleMarkupChange}
              style={{ width: '200px' }}
              className="form-control"
            />
          </Col>
          <Col xs="auto">
            <label
              htmlFor="markupPercentageInput"
              style={{
                display: 'block',
                marginBottom: '8px',
                fontWeight: 'bold',
              }}
            >
              % Preço Atacado
            </label>
            <input
              id="markupPercentageInput"
              type="number"
              placeholder="% Preço Atacado"
              value={markupPercentageAtacado}
              onChange={handleMarkupChangeAtacado}
              style={{ width: '200px' }}
              className="form-control"
            />
          </Col>
          {/* Botão ao lado */}
          <Col xs="auto">
            <button
              onClick={handleSendToBackend}
              disabled={isLoading}
              className="btn btn-primary d-flex align-items-center"
              style={{ marginTop: '30px' }} // Ajusta o botão para alinhar verticalmente com o input
            >
              {isLoading ? (
                <span>Enviando...</span>
              ) : (
                <>
                  <FaArrowRight style={{ marginRight: '8px' }} /> Enviar Preços
                </>
              )}
            </button>
          </Col>

          <Col xs="auto">
            <Form.Label>Produtos p/ pág</Form.Label>
            <Form.Select
              value={itemsPerPage}
              onChange={(e) => setItemsPerPage(e.target.value)}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Form.Select>
          </Col>

          <Col xs="auto">
            <Form.Label>Filtro Estoque</Form.Label>
            <Form.Select
              value={filtroEstoque}
              onChange={(e) => setFiltroEstoque(e.target.value)}
            >
              <option value="">Selecione</option>
              <option value="com_estoque">Com estoque</option>
              <option value="sem_estoque">Sem estoque</option>
            </Form.Select>
          </Col>

          <Col xs="auto">
            <div
              style={{
                minHeight: '100%',
                display: 'flex',
                alignItems: 'flex-end',
                marginTop: '30px',
              }}
            >
              <CustomButton
                disabled={!selectedProducts.length}
                title={`Ajustar Preços (${selectedProducts.length})`}
                onClick={() => setIsModalAjustarOpen(true)}
              />
            </div>
          </Col>
        </Row>

        <div
          className="mb-4"
          style={{ marginBottom: '20px', marginTop: '20px' }}
        >
          <table className="table table-hover">
            <thead className="table-light">
              <tr>
                <td colSpan={11}>
                  <div
                    style={{
                      display: 'flex',
                      gap: 5,
                    }}
                  >
                    <CustomButton
                      noMargin
                      title={`${
                        selectedProducts.length === filtered.length
                          ? `Desmarcar`
                          : 'Marcar'
                      } Todos`}
                      onClick={() => {
                        if (selectedProducts.length === filtered.length) {
                          setSelectedProducts([])
                        } else {
                          filtered.forEach((product) => {
                            const exists = selectedProducts.find(
                              (p) => p.SKU === product.SKU,
                            )

                            if (!exists) {
                              setSelectedProducts((pv) => [...pv, product])
                            }
                          })
                        }
                      }}
                    />

                    <CustomButton
                      noMargin
                      title="Limpar Seleção"
                      onClick={() => setSelectedProducts([])}
                      isDisabled={selectedProducts.length === 0}
                    />
                  </div>
                </td>
              </tr>

              <tr>
                <th>
                  <Form.Check
                    checked={filteredItems.every(
                      (item) =>
                        !!selectedProducts.find((i) => i.SKU === item.SKU)?.SKU,
                    )}
                    onClick={(e) => {
                      filteredItems.forEach((item) => {
                        if (e.target.checked) {
                          const exists = !!selectedProducts.find(
                            (p) => p.SKU === item.SKU,
                          )?.SKU

                          if (!exists) {
                            setSelectedProducts((pv) => [...pv, item])
                          }
                        } else {
                          setSelectedProducts((pv) =>
                            pv.filter((p) => p.SKU !== item.SKU),
                          )
                        }
                      })
                    }}
                  />
                </th>

                <Th
                  label="SKU"
                  value="SKU"
                />
                <Th
                  label="Produto"
                  value="DESCRICAO"
                />
                <Th
                  label="Formato"
                  value="FORMATO"
                />
                <Th
                  label="Est. Atual"
                  value="QTESTGER"
                />
                <Th
                  label="Custo"
                  value="PRECOCUSTO"
                />
                <Th
                  label="Venda"
                  value="PRECOVENDA"
                />
                <Th
                  label="Atacado"
                  value="PRECOATACADO"
                />
                <Th
                  label="Varejo Promo."
                  value="PRECOVAREJO_P"
                />
                <Th
                  label="Atacado Promo."
                  value="PRECOATACADO_P"
                />
                <Th label="Opções" />
              </tr>
            </thead>
            <tbody>
              {filteredItems.map((produto) => (
                <tr key={produto.CODPRODUTO}>
                  <td>
                    <Form.Check
                      checked={
                        !!selectedProducts.find(
                          (product) => product.SKU === produto.SKU,
                        )?.SKU
                      }
                      onClick={(e) => {
                        if (e.target.checked) {
                          const exists = !!selectedProducts.find(
                            (p) => p.SKU === produto.SKU,
                          )?.SKU

                          if (!exists) {
                            setSelectedProducts((prevState) => [
                              ...prevState,
                              produto,
                            ])
                          }
                        } else {
                          setSelectedProducts((pv) =>
                            pv.filter((p) => p.SKU !== produto.SKU),
                          )
                        }
                      }}
                    />
                  </td>
                  <td>{produto.SKU}</td>
                  <td>{produto.DESCRICAO}</td>
                  <td>
                    {produto.FORMATO === 'C' && (
                      <span className="badge bg-success">Composição</span>
                    )}
                    {produto.FORMATO === 'S' && (
                      <span className="badge bg-primary">Simples</span>
                    )}
                    {['C', 'S'].includes(produto.FORMATO) || (
                      <span className="badge bg-secondary">N/A</span>
                    )}
                  </td>

                  <td> {produto.QTESTGER?.toFixed(2) || 0}</td>
                  <td>
                    <input
                      type="number"
                      value={
                        novoCusto[produto.CODPRODUTO] || produto.PRECOCUSTO
                      }
                      onChange={(e) =>
                        setNovoCusto({
                          ...novoCusto,
                          [produto.CODPRODUTO]: e.target.value,
                        })
                      }
                      onBlur={() =>
                        handleAtualizar(
                          produto.CODPRODUTO,
                          'custo',
                          novoCusto[produto.CODPRODUTO] || produto.PRECOCUSTO,
                        )
                      }
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleAtualizar(
                            produto.CODPRODUTO,
                            'custo',
                            novoCusto[produto.CODPRODUTO] || produto.PRECOCUSTO,
                          )
                        }
                      }}
                      className="form-control form-control-sm"
                    />
                  </td>

                  <td>
                    <input
                      type="number"
                      value={
                        novoPrecoVenda[produto.CODPRODUTO] || produto.PRECOVENDA
                      }
                      onChange={(e) =>
                        setNovoPrecoVenda({
                          ...novoPrecoVenda,
                          [produto.CODPRODUTO]: e.target.value,
                        })
                      }
                      onBlur={() =>
                        handleAtualizar(
                          produto.CODPRODUTO,
                          'venda',
                          novoPrecoVenda[produto.CODPRODUTO] ||
                            produto.PRECOVENDA,
                        )
                      }
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleAtualizar(
                            produto.CODPRODUTO,
                            'venda',
                            novoPrecoVenda[produto.CODPRODUTO] ||
                              produto.PRECOVENDA,
                          )
                        }
                      }}
                      className="form-control form-control-sm"
                    />
                  </td>

                  <td>
                    <input
                      type="number"
                      value={
                        novoPrecoAtacado[produto.CODPRODUTO] ||
                        produto.PRECOATACADO
                      }
                      onChange={(e) =>
                        setNovoPrecoAtacado({
                          ...novoPrecoAtacado,
                          [produto.CODPRODUTO]: e.target.value,
                        })
                      }
                      onBlur={() =>
                        handleAtualizar(
                          produto.CODPRODUTO,
                          'atacado',
                          novoPrecoAtacado[produto.CODPRODUTO] ||
                            produto.PRECOATACADO,
                        )
                      }
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleAtualizar(
                            produto.CODPRODUTO,
                            'atacado',
                            novoPrecoAtacado[produto.CODPRODUTO] ||
                              produto.PRECOATACADO,
                          )
                        }
                      }}
                      className="form-control form-control-sm"
                    />
                  </td>

                  <td>
                    <input
                      type="number"
                      value={
                        novoPrecoAtacadoPromocional[produto.CODPRODUTO] ||
                        produto.PRECOATACADO_P
                      }
                      onChange={(e) =>
                        setnovoPrecoAtacadoPromocional({
                          ...novoPrecoAtacadoPromocional,
                          [produto.CODPRODUTO]: e.target.value,
                        })
                      }
                      onBlur={() =>
                        handleAtualizar(
                          produto.CODPRODUTO,
                          'promocionalatacado',
                          novoPrecoAtacadoPromocional[produto.CODPRODUTO] ||
                            produto.PRECOATACADO_P,
                        )
                      }
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleAtualizar(
                            produto.CODPRODUTO,
                            'promocionalatacado',
                            novoPrecoAtacadoPromocional[produto.CODPRODUTO] ||
                              produto.PRECOATACADO_P,
                          )
                        }
                      }}
                      className="form-control form-control-sm"
                    />
                  </td>

                  <td>
                    <input
                      type="number"
                      value={
                        novoPrecoPromocional[produto.CODPRODUTO] ||
                        produto.PRECOVAREJO_P
                      }
                      onChange={(e) =>
                        setNovoPrecoPromocional({
                          ...novoPrecoPromocional,
                          [produto.CODPRODUTO]: e.target.value,
                        })
                      }
                      onBlur={() =>
                        handleAtualizar(
                          produto.CODPRODUTO,
                          'promocionalvarejo',
                          novoPrecoPromocional[produto.CODPRODUTO] ||
                            produto.PRECOVAREJO_P,
                        )
                      }
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleAtualizar(
                            produto.CODPRODUTO,
                            'promocionalvarejo',
                            novoPrecoPromocional[produto.CODPRODUTO] ||
                              produto.PRECOVAREJO_P,
                          )
                        }
                      }}
                      className="form-control form-control-sm"
                    />
                  </td>
                  <td>
                    <CustomButton
                      onClick={() => handleProdFilho(produto.CODPRODUTO)}
                    >
                      <Eyeglasses />
                    </CustomButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Paginate />
          </div>
        </div>
      </div>

      <ProductModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        composicao={composicao}
      />

      <Modal
        show={showModalCusto}
        onHide={handleCloseModalCusto}
        dialogClassName="custom-modalzpl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Histórico de Custo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {historico.length === 0 ? (
            <p>Não há historico de custos para este produto.</p>
          ) : (
            <Table
              striped
              bordered
              hover
            >
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Custo</th>
                </tr>
              </thead>
              <tbody>
                {historico.map((item, index) => (
                  <tr key={index}>
                    <td>{item.DATA}</td>
                    <td>{item.CUSTO}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Modal.Body>
      </Modal>

      {isModalAjustarOpen && (
        <ModalAjustarPrecos
          isOpen={isModalAjustarOpen}
          onClose={() => setIsModalAjustarOpen(false)}
          products={selectedProducts}
          reset={reset}
        />
      )}
    </>
  )
}

export default CentroDeCusto
